// the unit's own app on its LAN address; only opens from a browser on the
// same network as the unit
export const localAppUrl = (localIp: string) => `http://${localIp}/`;
